export default __webpack_public_path__ + "static/media/iconeIncluirGrupo.5f20de9f.png";